import React, { useState, useEffect } from "react";
import fire from "../firebase";
import jsPDF from "jspdf";
import testCerti from "../sampleBack.png";
import FirstFont from "../FirstFont.ttf";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Feedback from "./feedback";

const Exsist = (props) => {
  const [data, setData] = useState({
    certificate: "",
    meet: "",
  });
  useEffect(() => {
    fire
      .firestore()
      .collection("settings")
      .doc("users")
      .get()
      .then((doc) => {
        if (doc.exists) {
          setData(doc.data());
        }
      });
  }, []);
  const [feedback, setFeedback] = useState(false);
  useEffect(() => {
    fire
      .firestore()
      .collection("feedback")
      .doc(`${props.user.sec}`)
      .get()
      .then((doc) => {
        if (doc.exists) {
          setFeedback(true);
        } else {
          setFeedback(false);
        }
      });
  }, []);
  const certi = () => {
    var doc = new jsPDF("landscape", "px", "letter", "false");
    doc.addImage(testCerti, "PNG", 0, 0, 600, 460);
    doc.addFileToVFS(FirstFont, "FirstFont");
    doc.setFont("FirstFont", "bold");
    doc.setFontSize(40);
    doc.setTextColor("#c9a04b");
    doc.text(
      doc.internal.pageSize.getWidth() / 2,
      200,
      `${props.user.name.toUpperCase()}`,
      "center"
    );

    doc.setFontSize(14);
    doc.setTextColor("#000");
    doc.addFileToVFS(FirstFont, "FirstFont");
    doc.setFont("FirstFont", "normal");
    doc.text(
      doc.internal.pageSize.getWidth() / 2,
      228,
      `OF ${props.user.coll.toUpperCase()}`,
      "center"
    );
    doc.save(`${props.user.name}.pdf`);
  };
  const notAllowed = () => {
    alert("You Cannot Download Certificate Right Now");
  };
  const nomeet = () => {
    alert("No Meeting Link is Available Right Now.");
  };
  const feedbackNot = () => {
    alert("First You Need To Fill Your Feedback Form To Download Certificate");
  };

  return (
    <Router>
      <div>
        <Switch>
          {feedback ? (
            ""
          ) : (
            <Route exact path="/feedback">
              <Feedback user={props.user} setFeedback={setFeedback} />
            </Route>
          )}
          <Route>
            <p className="information"></p>
            {data.meet === "" ? (
              <div
                style={{ textDecoration: "none" }}
                target="_blank"
                rel="noreferrer"
                onClick={nomeet}
              >
                <button className="meet">
                  <p>Join With&nbsp;&nbsp;</p>
                  <img src="/meet.svg" alt="Google Meet" />
                </button>
              </div>
            ) : (
              <a
                style={{ textDecoration: "none" }}
                target="_blank"
                rel="noreferrer"
                href={`${data.meet}`}
              >
                <button className="meet">
                  <p>Join With&nbsp;&nbsp;</p>
                  <img src="/meet.svg" alt="Google Meet" />
                </button>
              </a>
            )}
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <a
                style={{ textDecoration: "none" }}
                href="https://chat.whatsapp.com/KJa5EYB9gTm8acsqYH3i5D"
                target="_blank"
                rel="noreferrer"
              >
                <button className="whatsapp">
                  <img src="/whatsapp.svg" alt="whatsapp-icon.svg" />
                  <p>&nbsp;&nbsp;Join WhatsApp Group</p>
                </button>
              </a>
            </div>
            {feedback ? (
              ""
            ) : (
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Link style={{ textDecoration: "none" }} to="/feedback">
                  <button className="whatsapp">
                    <p>Give Feedback</p>
                  </button>
                </Link>
              </div>
            )}
          </Route>
        </Switch>

        <div className="footer">
          {data.certificate === "show" ? (
            <button
              onClick={feedback ? certi : feedbackNot}
              className="footer-btn down-visi"
            >
              <img src="/down.png" alt="download" />
              <span>&nbsp;&nbsp;Download Certificate</span>
            </button>
          ) : (
            <button onClick={notAllowed} className="footer-btn down">
              <img src="/down.png" alt="download" />
              <span>&nbsp;&nbsp;Download Certificate</span>
            </button>
          )}
        </div>
      </div>
    </Router>
  );
};

export default Exsist;
